import moment from 'moment-timezone'
import humanizeDuration from 'humanize-duration'

export function bookingToVisItem(booking) {
  return {
    id: booking.id,
    start: moment.parseZone(booking.start).local(true),
    end: moment.parseZone(booking.start).local(true).add(booking.duration, 'm'),
    className: booking.ride_type,
    destination: booking.destination,
    duration: booking.duration,
    group: booking.driver_id,
    luggage: booking.luggage,
    number: booking.number,
    origin: booking.origin,
    passengers: booking.passengers,
    rideType: booking.ride_type,
    vehicleType: booking.vehicle_type,
    style: `background: ${booking.color};`,
  }
}

export function visItemTooltip(item, t) {
  const duration = humanizeDuration(item.duration * 60 * 1000, {
    units: ['h', 'm'],
    round: true,
  })
  return `
    <h4 class="tooltip-header">#${item.number}</h4>
    <div class="tooltip-content">
      <div class="tooltip-row">
        <span class="tooltip-label">${t('bookings.pickup_date')}:</span>
        <span class="tooltip-value">${moment(item.start).format('lll')}</span>
      </div>
      <div class="tooltip-row">
        <span class="tooltip-label">${t('bookings.time')}:</span>
        <span class="tooltip-value">${duration}</span>
      </div>
      <div class="tooltip-row">
        <span class="tooltip-label">${t('bookings.from')}:</span>
        <span class="tooltip-value">${item.origin.address}</span>
      </div>
      <div class="tooltip-row">
        <span class="tooltip-label">${t('bookings.to')}:</span>
          <span class="tooltip-value">${item.destination.address}</span>
      </div>
      <div class="tooltip-row">
        <span class="tooltip-label">
          ${t('attributes.details.passengers.label')}:
        </span>
        <span class="tooltip-value">${item.passengers}</span>
      </div>
      <div class="tooltip-row">
        <span class="tooltip-label">
          ${t('attributes.details.luggage.label')}:
        </span>
        <span class="tooltip-value">${item.luggage}</span>
      </div>
      <div class="tooltip-row">
        <span class="tooltip-label">${t('bookings.vehicle_class')}:</span>
        <span class="tooltip-value">${item.vehicleType}</span>
      </div>
    </div>
`
}

export function visItemTemplate(item) {
  const start = toTimeString(item.start)
  const end = toTimeString(item.end)
  const originIcon = item.origin.is_airport ? 'airplane2' : ''
  const destinationIcon = item.destination.is_airport ? 'airplane2' : ''
  return `
    <div class="start">${start}</div>
    <div class="origin-icon"><i class="icon-${originIcon}"></i></div>
    <div class="origin">${item.origin.address}</div>
    <div class="end">${end}</div>
    <div class="destination-icon"><i class="icon-${destinationIcon}"></i></div>
    <div class="destination">${item.destination.address}</div>
    <div class="passengers"><i class="icon-man"></i> ${item.passengers}</div>
    <div class="luggage"><i class="icon-briefcase3"></i> ${item.luggage}</div>
    <div class="vehicle_type">${item.vehicleType}</div>
  `
}

export function visGroupTemplate(group) {
  if (!group) {
    return ''
  }
  return `
    <div class="driver-name">${group.content}</div>
    <div class="vehicle-info">
      <div class="model">${group.vehicleModel}</div>
      <div class="plate">${group.vehicleNumber}</div>
    </div>
  `
}

function toTimeString(date) {
  if (!date) {
    return null
  }
  const d = new Date(date)
  return `${d.getHours().toString().padStart(2, '0')}:${d
    .getMinutes()
    .toString()
    .padStart(2, '0')}`
}
